import { apiCtmarketlist, ApiCtmarketlistType } from "@/api/acendex/ctmarketlist";
import { useFetch } from "@/lib/fetch-tools";
import { effect, signal } from "@preact-signals/safe-react";

export const marketList = signal<ApiCtmarketlistType['response']['data']['records']>([])
export const useMarketlistData = () => {
  const { data, isLoading } = useFetch(apiCtmarketlist, {
    fetchParams: {
      pageNum: 1,
      pageSize: 100,
    },
  });

  effect(() => {
    if (data) {
      marketList.value = data.data.records;
    }
  });

  return {
    data,
    isLoading,
  };
};
